import { useAppSelector } from "../../../../../../../services/redux/hooks/use-selector";
import { selectLoading } from "../../../../../redux/selectors";
import { AppLoading } from "../../../../../../../shared/components/AppLoading";
import { BotChatSelector } from "../../../../BotChatSelector";
import { NormalizedStorageObject } from "../../../../../../../services/api/instances/storageApi/types/object_types";
import {
  ChatbotValue,
  ChatObject,
} from "../../../../../../../services/api/instances/botApi/types";
import { TValueForService } from "../../../../../../../services/api/instances/storageApi/types/service_types";
import { useTranslation } from "react-i18next";
import { useChatsByRef } from "../../../../../hook/use-chat-by-ref";
import { useGenericAutocomplete } from "../../../../../../../common/GenericAutocomplete/hook/use-generic-autocomplete";
import { useMemo } from "react";
import { BotObject } from "../../../../../../../services/api/methodsTypes";
import { getUpdatedChatbotValue } from "../../../../../helpers/getUpdatedChatbotValue";

interface Props {
  bot: NormalizedStorageObject<ChatbotValue>;
  botRef: string | null | undefined;
  saveChatbotValue: (
    value: TValueForService<"ai_agents_telegram_bots">,
  ) => void;
}

export const SecurityChatSelect = (props: Props) => {
  const isLoading = useAppSelector(selectLoading);
  const chats = useChatsByRef(props.botRef);
  const option = useMemo(() => {
    const currentChat = chats.find(
      (chat) =>
        chat.chat_id === props.bot?.value?.tg_bot_object?.secure_chat_id,
    );
    return currentChat ? currentChat : null;
  }, [props.bot?.id]);

  const { selectAutocompleteValue, handleSelectAutocompleteOption } =
    useGenericAutocomplete<ChatObject | null>(option, props.bot?.id);
  const { t } = useTranslation();

  const onSelectChat = (chat: ChatObject | null) => {
    handleSelectAutocompleteOption(chat);
    const updatedValue = getUpdatedChatbotValue(props.bot.value, {
      secure_chat_id: chat?.chat_id,
    });
    props.saveChatbotValue(updatedValue);
  };

  return (
    <>
      {!isLoading ? (
        <BotChatSelector
          chats={chats}
          chat={selectAutocompleteValue}
          onSelectChat={onSelectChat}
          emptyOptionLabel={t("chatbot.no_chat-placeholder")}
          isDisabled={!props.bot?.value?.tg_bot_object?.security_check}
        />
      ) : (
        <AppLoading small />
      )}
    </>
  );
};
